import React from 'react';

import { flagStyles } from '../settings';

const SvgNC = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3816px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgNC;
